<div class="sam-form-row">
   <label class="k-checkbox-label" for="showAvatar">
      <input
         type="checkbox"
         id="showAvatar"
         [checked]="showAvatar$ | async"
         (click)="changeShowAvatar($event.currentTarget.checked)"
         class="k-checkbox"
      />
      {{ 'brick.brick_definitions.directory_details.settings.show_avatar' | translate }}
   </label>
</div>

<div class="sam-form-row">
   <label class="k-checkbox-label" for="showFieldNames">
      <input
         type="checkbox"
         id="showFieldNames"
         [checked]="showFieldNames$ | async"
         (click)="changeShowFieldNames($event.currentTarget.checked)"
         class="k-checkbox"
      />
      {{ 'brick.brick_definitions.directory_details.settings.show_field_names' | translate }}
   </label>
</div>

<div class="sam-form-row" fxLayout="row">
   <div fxFlex="1 1 50">
      <div style="padding: 0.5em; font-weight: bold">
         {{ 'brick.brick_definitions.directory_details.settings.visible_fields' | translate }}
      </div>
      <div class="drop-container">
         <div
            cdkDropList
            #visibleList="cdkDropList"
            [cdkDropListData]="visibleFields"
            [cdkDropListConnectedTo]="[hiddenList]"
            class="fields-list"
            (cdkDropListDropped)="drop($event)"
         >
            <div class="visible-box" *ngFor="let item of visibleFields" cdkDrag>
               <div>
                  <fa-icon [icon]="item.columnTyp.columnIcon" [fixedWidth]="true"></fa-icon>
                  {{ item | directoryColumnTitle | async }}
               </div>
               <div *cdkDragPreview class="sam-margin sam-center sam-padding dragged-item">
                  <fa-icon [icon]="item.columnTyp.columnIcon" [fixedWidth]="true"></fa-icon>
                  {{ item | directoryColumnTitle | async }}
               </div>
            </div>
         </div>
      </div>
   </div>
   <div fxFlex="1 1 50">
      <div
         [ngStyle]="{
            padding: '0.5em',
            'font-weight': 'bold'
         }"
      >
         {{ 'brick.brick_definitions.directory_details.settings.hidden_fields' | translate }}
      </div>
      <div class="drop-container">
         <div
            cdkDropList
            #hiddenList="cdkDropList"
            [cdkDropListData]="hiddenFields"
            [cdkDropListConnectedTo]="[visibleList]"
            class="fields-list"
            (cdkDropListDropped)="drop($event)"
         >
            <div class="hidden-box" *ngFor="let item of hiddenFields" cdkDrag>
               <div>
                  <fa-icon [icon]="item.columnTyp.columnIcon" [fixedWidth]="true"></fa-icon>
                  {{ item | directoryColumnTitle | async }}
               </div>
               <div *cdkDragPreview class="sam-margin sam-center sam-padding dragged-item">
                  <fa-icon [icon]="item.columnTyp.columnIcon" [fixedWidth]="true"></fa-icon>
                  {{ item | directoryColumnTitle | async }}
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
